<template>
  <div class="pd-synthesizeWrapper">
    <div class="pd-inputWrapper">
      <div class="pd-subTitle">{{ $t("textSynthesize.subTitle") }}</div>
      <textarea class="pd-textInput" id="textInput" ref="input" :placeholder="$t('textSynthesize.textInputPlaceholder')"
        name="textInput" rows="4" cols="50" v-model="inputText">
      </textarea>
      <div class="pd-fullScreenButton">
        <FullScreenInput :readOnly="true" :inputText="inputText" :onClose="onClose" :key="fsKey" />
      </div>
      <div class="pd-characterCountWrapper">
        <div style="margin-right: 4px" :class="[
          inputText.length > availableCount ? 'pd-characterWarning' : '',
        ]">
          {{ inputText.length }}
        </div>
        /
        <div style="margin-left: 4px">{{ availableCount }}</div>
      </div>
    </div>
    <div class="pd-settingsWrapper">
      <div class="pd-settingsTitleWrapper">
        <div class="pd-settingsTitle">
          <div class="d-flex align-center" style="height: 18px; margin-right: 5px; gap:10px">
            <SettingsIcon />
            {{ $t("textSynthesize.settings") }}
          </div>
        </div>
      </div>
      <div class="pd-toolsWrapper">
        <v-row class="px-auto mx-auto">
          <v-col :class="$vuetify.breakpoint.mobile ? 'd-flex flex-column align-center' : ''" cols="12" md="12" lg="6">
            <div class="pd-soundSpeed">
              {{ $t("textSynthesize.chooseVoice") }}
            </div>
            <div class="pd-speedSelectWrapper">
              <v-select offset-y :items="voice" v-model="config.voiceID" item-text="people" item-value="value"
                item-color="gray" dense outlined>
              </v-select>
            </div>
          </v-col>
          <v-col :class="$vuetify.breakpoint.mobile ? 'd-flex flex-column align-center' : ''" cols="12" md="12" lg="6">
            <div class="pd-soundSpeed">Арын ая</div>
            <div class="pd-speedSelectWrapper">
              <v-select offset-y :items="background" v-model="config.background" item-text="sound" item-value="value"
                item-color="gray" dense outlined>
              </v-select>
            </div>
          </v-col>

          <v-col :class="$vuetify.breakpoint.mobile ? 'd-flex flex-column align-center' : ''" cols="12" md="12" lg="6">
            <div class="pd-soundSpeed">{{ $t("textSynthesize.soundSpeed") }}</div>
            <div class="pd-speedSelectWrapper">
              <v-select offset-y :items="voiceSpeed" v-model="config.selectedSpeed" item-text="title" item-value="value"
                item-color="gray" dense outlined>
              </v-select>
            </div>
          </v-col>

          <v-col :class="$vuetify.breakpoint.mobile ? 'd-flex flex-column align-center' : ''" cols="12" md="12" lg="6">
            <div class="pd-soundSpeed">Хоолойны өнгө</div>
            <div class="pd-speedSelectWrapper">
              <v-select offset-y :items="pitch" v-model="config.pitch" item-text="title" item-value="value"
                item-color="gray" dense outlined>
              </v-select>
            </div>
          </v-col>

        </v-row>
        <div class="mx-auto mb-5">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="btnStyle" @click="testVoice(3)" :disabled="buyLoading" v-on="on" v-bind="attrs">
                <v-progress-circular v-if="buyLoading" :size="25" :width="4" color="#ffffff" indeterminate>
                </v-progress-circular>
                 <img  src="/assets/play.svg" v-if="!buyLoading" style="width:20px; height:20px; filter: brightness(0) invert(1);" />
              </v-btn>
            </template>
            <span>{{ $t("textSynthesize.playTooltip") }}</span>
          </v-tooltip>
        </div>
        <v-btn class="pd-synthesizeButton" @click="moveSynthesizeData" :loading="loading">
          <div style="margin-right: 10px">
            <MicWhiteIcon />
          </div>
          {{ $t("textSynthesize.synthesizeBtn") }}
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="showDialog" persistent max-width="380">
      <v-card class="ts-dialogWrapper">
        <div class="ts-dialogTitleWrapper">
          <div class="ts-dialogTitle">
            {{ $t("textSynthesize.dialogTitle") }}
          </div>
        </div>
        <div class="ts-dialogQuestion">
          {{ $t("textSynthesize.dialogQuestion") }}
        </div>
        <div class="ts-dialogActionWrapper">
          <v-btn color="darken-1" class="ts-closeBtn" text @click="closeDialog">{{ $t("textSynthesize.dialogCloseBtn")
          }}</v-btn>
          <v-btn class="ts-warningBtn" text @click="jumpToFile">{{
              $t("textSynthesize.dialogYesBtn")
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SettingsIcon from "../components/icons/SettingsIcon";
import MicWhiteIcon from "../components/icons/MicWhiteIcon";
import FullScreenInput from "../components/FullScreenInput";
import { mapActions } from "vuex";
export default {
  
  name: "TextSynthesize",
  components: {
    SettingsIcon,
    MicWhiteIcon,
    FullScreenInput,
  },
  props: {
    config: {
      inputText: String,
      voiceID: String,
      selectedSpeed: Number,
      background: String,
      pitch: Number,
    },
    synthesize: { type: Function },
  },
  watch: {
    inputText: function () {
      this.updateFullScreenKey();
    },
  },
  data: () => ({
    buyLoading : false,
    loading: false,
    showDialog: false,
    voice: [
      { people: "Эмэгтэй (хуучин)", value: "FEMALE1" },
      { people: "Эмэгтэй 1", value: "FEMALE1v2" },
      { people: "Эмэгтэй 2", value: "FEMALE2v2" },
      { people: "Эмэгтэй 3", value: "FEMALE3v2" },
      { people: "Эмэгтэй 4", value: "FEMALE4v2" },
      { people: "Эрэгтэй (хуучин)", value: "MALE1" },
      { people: "Эрэгтэй 1", value: "MALE1v2" },
      { people: "Эрэгтэй 2", value: "MALE2v2" },
      { people: "Эрэгтэй 3", value: "MALE3v2" },
      { people: "Эрэгтэй 4", value: "MALE4v2" },
    ],
    background: [
      { sound: "Лимбэний ая", value: "limbe" },
      { sound: "Аягүй", value: "none" },
      { sound: "Birthday", value: "birthday" },
      { sound: "Chill", value: "chill" },
      { sound: "Epic", value: "epic" },
      { sound: "Horror", value: "horror" },
      { sound: "Jazz", value: "jazz" },
      { sound: "Piano", value: "piano" },
      { sound: "Rain", value: "rain" },
      { sound: "Traffic", value: "traffic" },
    ],
    inputText: "",
    characterCount: 0,
    fsKey: 0,
    availableCount: 3750,
    pitch: [
      {
        value: 0.5,
        title: "Маш бүдүүн",
      },
      {
        value: 0.75,
        title: "Бүдүүвтэр",
      },
      {
        value: 1,
        title: "Хэвийн",
      },
      {
        value: 1.25,
        title: "Нарийвтар",
      },
      {
        value: 1.5,
        title: "Нарийн",
      },
      {
        value: 2.00,
        title: "Маш нарийн",
      },
    ],
    voiceSpeed: [
      {
        value: 0.5,
        title: "0.5x - Удаан",
      },
      {
        value: 0.75,
        title: "0.75x - Удаавтар",
      },
      {
        value: 1,
        title: "Хэвийн",
      },
      {
        value: 1.25,
        title: "1.25x - Хурдавтар",
      },
      {
        value: 1.5,
        title: "1.5x - Хурдан",
      },
      {
        value: 1.75,
        title: "1.75x - Маш хурдан",
      },
    ],
    testVoiceUrl: [
      "https://reader.chimege.com:/api/audio/3/61396635616262342d346230302d343938662d396463362d333130393538306561356139.wav",
      "https://reader.chimege.com:/api/audio/3/30346438313264352d613434642d346135322d626163342d306164343236376365633234.wav",
    ],
  }),
  computed: {
    getCurrentRoute: function () {
      return this.$router.currentRoute.name;
    },
  },
  mounted() {
    this.focus = this.getCurrentRoute.replace("/", "");
    this.inputText = this.config.inputText;
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    jumpToFile() {
      this.$router.push("/books").catch((err) => {
        console.log(err);
      });
    },
    onClose(newText) {
      this.inputText = newText;
    },
    updateFullScreenKey() {
      this.fsKey++;
    },
    ...mapActions(["showErrorMessage"]),
    moveSynthesizeData() {
      let text = this.inputText.trim();
      if (this.inputText.length === 0) {
        this.showErrorMessage({
          message: this.$t("textSynthesize.errorMsg1"),
          timeout: 3000,
        });
      } else if (text.split(" ").length < 2 && this.config.voiceID === 2) {
        this.showErrorMessage({
          message: this.$t("textSynthesize.errorMsg2"),
          timeout: 3000,
        });
      } else if (this.inputText.length > this.availableCount) {
        this.showDialog = true;
        // this.showErrorMessage("Хөрвүүлэх тэмдэгтийн тоо хэтэрсэн байна.");
      } else {
        this.loading = true;
        this.synthesize(
          this.inputText,
          this.config.voiceID,
          this.config.selectedSpeed,
          this.config.background,
          this.config.pitch
        );
      }
    },
    async testVoice() {
      this.buyLoading = true
      var response = await synthesize(this.config.voiceID, this.config.selectedSpeed, this.config.pitch, this.config.background)
      this.buyLoading = false
      let blob = await response.blob()
      const url = URL.createObjectURL(blob)
      var audio = new Audio(url);
      audio.play()
    }
  },
};
async function synthesize(voiceID, speed, pitch, background) {
  let resp = await fetch(`${process.env.VUE_APP_BASE_URL}/v2/testPlay?voiceID=${voiceID}&speed=${speed}&pitch=${pitch}&background=${background}`, {
    method: 'POST',
  })
  return resp
}
</script>
<style scoped>
.pd-synthesizeButton {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
}

.btnStyle {
  background-color: #787ff7 !important;
  color: #ffffff;
  /* box-shadow: 0 3px 5px 0 rgba(50, 50, 247, 0.3); */
  padding: 8px 20px !important;
  outline: none;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  font-weight: 500;
  border-radius: 6px;
  text-transform: capitalize;
  width: 100%;
  cursor: pointer;
}
.pd-fullScreenButton {
  position: absolute;
  right: 16px;
  top: 36px;
}

.pd-subTitle {
  font-size: 14px;
  font-weight: 700;
  color: #767676;
  margin-bottom: 10px;
}

.ts-warningBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.ts-closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.ts-dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.ts-dialogQuestion {
  font-size: 14px;
  line-height: 16px;
  color: #767676;
}

.ts-dialogTitle {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  line-height: 18px;
}

.pd-synthesizeWrapper {
  display: flex;
}

.ts-dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  color: #d23636;
}

.pd-inputWrapper {
  width: 60%;
  display: flex;
  position: relative;
  flex-direction: column;
}

.pd-settingsWrapper {
  width: calc(40% - 40px);
  margin-left: 40px;
}

.pd-settingsTitleWrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
}

.pd-toolsWrapper {
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: fit-content;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  justify-content: space-between;
}

.pd-checkBoxTitle,
.pd-soundSpeed {

  font-weight: 500;
  font-size: 14px;
  color: #231f20;
  margin-bottom: 0px;
}

.pd-soundSpeed {
  margin-top: 0px;
}

.pd-speedSelectWrapper {
  display: flex;
}

@media (max-width:930px) {
  .pd-speedSelectWrapper {
    width: 300px !important;

    max-width: 300px !important;
  }
}

.v-input:focus {
  outline: none !important;
  color: #777ff6 !important;
}

.pd-checkboxesWrapper {
  display: flex;
  flex-direction: column;
}

.pd-checkboxWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.pd-audioTitleStyle {
  font-size: 14px;
  font-weight: 500;
  color: #231f20;
  line-height: 16px;
}

.pd-audioInfoStyle {
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  line-height: 24px;
}

.pd-playButton {
  display: flex;
  height: 16px;
  margin-left: 10px;
  cursor: pointer;
}

.pd-speedPlayButton {
  height: 16px;
  margin-top: 12px;
  margin-bottom: 12px;
  cursor: pointer;
}

.v-input {
  margin: 0;
}

.v-radio {
  margin: 0 !important;
}

.v-label {
  font-size: 14px !important;
  color: #000000 !important;
}

.pd-textInput {
  width: 100%;
  resize: none;
  padding: 16px;
  height: 352px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
}

.pd-textInput:focus {
  outline: none;
  border: 1px solid #767676;
}

.pd-textInput:hover {
  border: 1px solid #767676;
}

.pd-characterCountWrapper {
  display: flex;
  position: absolute;
  font-size: 14px;
  color: #767676;
  bottom: 16px;
  right: 16px;
}

.pd-characterWarning {
  color: red;
}

.ts-dialogWrapper {
  padding: 31px 38px;
}

.ts-dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

@media screen and (max-width: 768px) {
  .pd-dialogWrapper {
    padding: 20px;
  }
}

@media screen and (max-width: 930px) {
  .pd-synthesizeWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .pd-inputWrapper {
    width: 100%;
  }

  .pd-settingsWrapper {
    width: 100%;
    margin: 0;
  }

  .pd-toolsWrapper {
    height: auto;
  }
}

@media screen and (max-width: 599px) {
  .pd-subTitle {
    display: flex;
    justify-content: center;
  }
}
</style>
